import { useState } from "react";
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import { Button, Form, Radio, Space, Spin, Tabs } from 'antd';
import Utilisateur from "../../../Models/Utilisateur";
import type { TabsProps } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import SweetAlert from "sweetalert2";
import Swal from "sweetalert2";
import Tab1 from "./Tab1";
import { Box, Typography } from '@mui/material';
import Tab4 from './Tab1';
import SearchModal from "../../SearchModal";
import InputForm from "../../InputT";
import SelectOption from "../../SelectOption";
import DataSelect from '../../../Types/DataSelect'
import ParamsPicklist from "../../../Types/ParamsPicklist";
import SearInputG from "../../SearchInput"
import { Crypter } from "../../../Functions/Security/Crypter";
import Data from '../../../Data/Data.json';
import axios from "axios";
import ReformatDate from '../../../Functions/Traitement/ReformatDate'
import Demand from '../../../Models/MCommis';
import formatDate from "../../../Functions/Traitement/fomatDate";
import { date } from "yup";
import CheckBox from "../../CheckBox";
import type { CheckboxChangeEvent } from 'antd/es/checkbox';

import CheckStan from "../../Prints/CheckStan";


const GestionBudget = () => {

    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const authHeader = useAuthHeader()
    const [Onfinis, SetOnfinis] = useState<number>(0);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [SearchGlobal, setSearchGlobal] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [Consultactv, setConsulte] = useState(false);
    const [Ajoutactv, setAjoute] = useState(false);
    const [Modifactv, setModife] = useState(true);
    const [Supprimactv, setSupprime] = useState(true);
    const [Enregactv, setEnrege] = useState(true);
    const [Actuactv, setActue] = useState(true);
    const [Annulactv, setAnnule] = useState(true);
    const [FormAct, setFormactve] = useState(true);
    const [sbmit, setSbmit] = useState("")
    const [Idbutton, setIdbutton] = useState(false);

    // Handle function
    function HandleConsult() {
        setConsulte(true);
        setAjoute(true);
        setModife(false);
        setAnnule(false);
        setSupprime(false)
        consult();
    }

    function HandleAjout() {
        setConsulte(true);
        setAjoute(true);
        setEnrege(false);
        setActue(false);
        setAnnule(false);
        setFormactve(false);
        setSbmit('add')

    }

    function HandleModif() {
        setEnrege(false);
        setModife(true);
        setActue(false);
        setAnnule(false)
        setFormactve(false);
        setSbmit('modif')
        setSupprime(true)
    }

    function HandleSupp() {
        setSbmit('supp')
    }

    function HandleAnnul() {

        setConsulte(false);
        setAjoute(false);
        setModife(true);
        setEnrege(true);
        setSupprime(true);
        setActue(true);
        setAnnule(true);
        form.resetFields();
        setFormactve(true);
        setSbmit('')
    }



    // GESTION DES ITEMS
    const items: TabsProps['items'] = [
        {
            key: '1',
            label: (
                <span id='x'>
                    <UserOutlined />
                    Gestion Budgetaire
                </span>
            ),
            children: <>
                <div className='tabItem' >
                    <div style={{ display: 'block flow' }}  >
                        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}  >
                            <legend> Mise en place d'un Budget </legend>
                            <Box>
                                <Box style={{ marginTop: -20 }}>
                                    <SearInputG width={0} dissabledLib={true} dissabledCode={Idbutton} notRequired Titre=" Recherche" label='Numéro de Compte' name="" Taille1={140} Taille2={250}   /* etat={props.setSearchGlobal} */ form={form} />
                                </Box>
                                <Box style={{ marginTop: -10 }}>
                                    <InputForm width={3} label="Nom du Compte" type="texte" name="" taille={200} />
                                </Box>
                                <Box style={{ marginTop: -10 }}>
                                    <InputForm width={3} label="Ligne Budgetaire" type="texte" name="" taille={200} />
                                </Box>
                                <Box style={{ marginTop: -10 }}>
                                    <InputForm width={3} label="Type de Prévision" type="texte" name="" taille={200} />
                                </Box>
                            </Box>
                            <Box style={{}}>
                                <fieldset className="bordure1" style={{ }}>
                                    <legend style={{ textAlign: "center", width: 200, paddingLeft: 10, borderRadius: 10 }} > BudGet </legend>
                                    <Box style={{ display: 'flex',marginTop: -20 }}>
                                        <Box style={{ marginTop: -10 }}>
                                            <InputForm width={9} label="Montant Annuel" type="number" name="" taille={200} />
                                        </Box>
                                        <Box style={{ marginTop: -10 }}>
                                            <InputForm width={9} label="Reste à repartir" type="number" name="" taille={200} />
                                        </Box>
                                    </Box>
                                    <Box style={{ display: 'flex' }}>
                                        <Box style={{ display: 'flex' }}>
                                            <Box>
                                                <label style={{ marginLeft: 120 }}> Montant </label>
                                                <Box style={{ marginTop: -10 }}>
                                                    <InputForm width={9} label="Janvier" type="number" name="" taille={120} />
                                                </Box>
                                                <Box style={{ marginTop: -10 }}>
                                                    <InputForm width={9} label="Février" type="number" name="" taille={120} />
                                                </Box>
                                                <Box style={{ marginTop: -10 }}>
                                                    <InputForm width={9} label="Mars" type="number" name="" taille={120} />
                                                </Box>
                                                <Box style={{ marginTop: -10 }}>
                                                    <InputForm width={9} label="Avril" type="number" name="" taille={120} />
                                                </Box>
                                                <Box style={{ marginTop: -10 }}>
                                                    <InputForm width={9} label="Mai" type="number" name="" taille={120} />
                                                </Box>
                                                <Box style={{ marginTop: -10 }}>
                                                    <InputForm width={9} label="Juin" type="number" name="" taille={120} />
                                                </Box>
                                            </Box>
                                            <Box style={{ marginLeft: -10 }}>
                                                <label style={{ marginLeft: 50 }}> Taux </label>
                                                <Box style={{ marginTop: -10 }}>
                                                    <InputForm width={10} label="" type="number" name="" taille={120} />
                                                </Box>
                                                <Box style={{ marginTop: -10 }}>
                                                    <InputForm width={10} label="" type="number" name="" taille={120} />
                                                </Box>
                                                <Box style={{ marginTop: -10 }}>
                                                    <InputForm width={10} label="" type="number" name="" taille={120} />
                                                </Box>
                                                <Box style={{ marginTop: -10 }}>
                                                    <InputForm width={10} label="" type="number" name="" taille={120} />
                                                </Box>
                                                <Box style={{ marginTop: -10 }}>
                                                    <InputForm width={10} label="" type="number" name="" taille={120} />
                                                </Box>
                                                <Box style={{ marginTop: -10 }}>
                                                    <InputForm width={10} label="" type="number" name="" taille={120} />
                                                </Box>
                                            </Box>
                                        </Box>
                                        <Box style={{ display: 'flex' }}>
                                            <Box>
                                                <label style={{ marginLeft: 150 }}> Montant </label>
                                                <Box style={{ marginTop: -10 }}>
                                                    <InputForm width={11} label="Juillet" type="number" name="" taille={120} />
                                                </Box>
                                                <Box style={{ marginTop: -10 }}>
                                                    <InputForm width={11} label="Août" type="number" name="" taille={120} />
                                                </Box>
                                                <Box style={{ marginTop: -10 }}>
                                                    <InputForm width={11} label="Septembre" type="number" name="" taille={120} />
                                                </Box>
                                                <Box style={{ marginTop: -10 }}>
                                                    <InputForm width={11} label="Octobre" type="number" name="" taille={120} />
                                                </Box>
                                                <Box style={{ marginTop: -10 }}>
                                                    <InputForm width={11} label="Novembre" type="number" name="" taille={120} />
                                                </Box>
                                                <Box style={{ marginTop: -10 }}>
                                                    <InputForm width={11} label="Décembre" type="number" name="" taille={120} />
                                                </Box>
                                            </Box>
                                            <Box style={{ marginLeft: -10 }}>
                                                <label style={{ marginLeft: 50 }}> Taux </label>
                                                <Box style={{ marginTop: -10 }}>
                                                    <InputForm width={11} label="" type="number" name="" taille={120} />
                                                </Box>
                                                <Box style={{ marginTop: -10 }}>
                                                    <InputForm width={11} label="" type="number" name="" taille={120} />
                                                </Box>
                                                <Box style={{ marginTop: -10 }}>
                                                    <InputForm width={11} label="" type="number" name="" taille={120} />
                                                </Box>
                                                <Box style={{ marginTop: -10 }}>
                                                    <InputForm width={11} label="" type="number" name="" taille={120} />
                                                </Box>
                                                <Box style={{ marginTop: -10 }}>
                                                    <InputForm width={11} label="" type="number" name="" taille={120} />
                                                </Box>
                                                <Box style={{ marginTop: -10 }}>
                                                    <InputForm width={11} label="" type="number" name="" taille={120} />
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>

                                </fieldset>
                            </Box>
                        </Box>
                    </div>
                </div >
            </>,
        }
    ];

    // function consult 
    function consult() {

    }

    // function Onfinish
    const onFinish = (values: any) => {

    }

    // function de verification 
    const onFinishFailed = async (errorInfo: any) => {
        var errors: any = [];
        errorInfo.errorFields.map((error: any) => {
            errors.push(error.name + "");
        })

        SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })
    };

    const verifSubmit = () => {
        if (!isSubmit) {
            Swal.fire({ title: "Attention", text: "Veillez remplir tous les champs", icon: "warning" })
        }
    };

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'> <b> Interêt et Commission : {window.location.pathname.toUpperCase()} </b> </Typography>
            <Spin spinning={loading} size='large' style={{ color: '#116599' }}>
                <Form disabled={FormAct} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"#116599"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' className='bt_add' disabled={Consultactv} onClick={() => { HandleConsult() }} type="ghost" htmlType="button" block  >
                                    Consulter
                                </Button>
                                <Button size='large' className='bt_add' disabled={Ajoutactv} onClick={() => { HandleAjout() }} type="ghost" htmlType="button" block  >
                                    Ajouter
                                </Button>
                                <Button size='large' className='bt_add' disabled={Modifactv} onClick={() => { HandleModif() }} type="ghost" htmlType="button" block  >
                                    Modifier
                                </Button>
                                <Button size='large' className='bt_add' disabled={Enregactv} type="ghost" htmlType="submit" block>
                                    Enregistrer
                                </Button>
                                <Button size='large' className='bt_add' disabled={Supprimactv} onClick={() => { HandleSupp() }} type="ghost" htmlType="submit" block>
                                    Supprimer
                                </Button>
                                <Button size='large' className='bt_add' disabled={Actuactv} onClick={() => { form.resetFields() }} type="ghost" htmlType="button" block  >
                                    Actualiser
                                </Button>
                                <Button size='large' disabled={Annulactv} onClick={() => { HandleAnnul() }} className='bt_add' type="ghost" htmlType="reset" block>
                                    Annuler
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div>
                            <div >
                                <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                            </div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );



}

export default GestionBudget;